import { SortCell, TextCell } from "../cells";
import { Column, RowData } from "../types";

interface RowDataWithRecordDateStart extends RowData {
  recordDateStart: string;
}

export const recordDateStartColumn: Column<RowDataWithRecordDateStart> = {
  label: (
    <SortCell sortKey="record_date_start" emphasis="medium">
      Record Start
    </SortCell>
  ),
  width: "1fr",
  cell: (filing) => (
    <TextCell emphasis="medium">{filing.recordDateStart || "-"}</TextCell>
  ),
};
